import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_EMP_FORMPOST, GET_EMP_DETAILDATA } from "../../actions";

import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
  hasPermission,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "employee/city";
var modulePath = "/hrms/city";
var moduleName = "City";
const moduleID = 45;
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.match.params?.editID ?? '';
    this.state = {
      editID:editID,
      postdata: {
        cityName: "",
        cityStatus: "",
      },
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      var params = {
        params:'',
        url: `${module}/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].success === true) {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].success === true) {
          var result = nextProps.detaildata[0].result;

          var cityStatus = result.cityStatus === "A" ? "Active" : "In Active";
          var status =
            result.cityStatus !== "" && result.cityStatus !== null
              ? {
                  label: cityStatus,
                  value: result.cityStatus,
                }
              : "";
          var clientupdatedata = {
            cityName: result.cityName,
            cityStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      cityName: postData.cityName,
      cityStatus: postData.cityStatus?.value ?? 'I',
    };

    var post_url = `${module}/create`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="city" {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.empformpost,
    detaildata: state.empdetaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_EMP_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_EMP_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { cityName, cityStatus } = props.fields;

  return {
    fields: [ "cityName", "cityStatus"],
    validations: {
      cityName: [[isEmpty, cityName]],
      cityStatus: [[isSingleSelect, cityStatus]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgcityName,
      errMsgStatus = "";
    if ($validation.cityName.error.reason !== undefined) {
      errMsgcityName = $validation.cityName.show && (
        <span className="error">{$validation.cityName.error.reason}</span>
      );
    }
    if ($validation.cityStatus.error.reason !== undefined) {
      errMsgStatus = $validation.cityStatus.show && (
        <span className="error">{$validation.cityStatus.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-5">
              <label className="form-label">
                City Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="City Name"
                name="cityName"
                value={fields.cityName}
                {...$field("cityName", (e) =>
                  onChange("cityName", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcityName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.cityStatus}
                onChange={this.handleSelectChange.bind(this, "cityStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: 'A', label: "Active" },
                  { value: 'I', label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
